// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"AdminSettings_Sidebar_sidebar__1DJX7"};